export default __webpack_public_path__ + "static/media/C0000.46810c0c.png";